module.exports = __webpack_public_path__ + "static/img/73 (1).516e3cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/73 (1).jpg
// module id = 8tkW
// module chunks = 0